@if (hasCurrentAITariffDetail) {
<div class="card card-nb h-100">
    <div class="card-body pb-0">
      <div class="row">
        <div class="col-12 h2">
          <app-subscription-title></app-subscription-title>
          <h2>{{ 'ai-tariff-card_headline' | i18next }}</h2>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12 highlighted">
          @if (hasScheduledOrder) {
            <span>{{ 'ai-tariff-card_ordered_ai_tariff_text' | i18next: { currentAiTariff: (currentTariffString | i18next), orderedAiTariff: (scheduledTariffString | i18next), date: scheduledTariffOrderDate} }}</span>
          } @else {
            <span>{{ 'ai-tariff-card_current_ai_tariff_text' | i18next: { currentAiTariff: (currentTariffString | i18next) } }}</span>
          }
        </div>
      </div>
      @if (isAdmin) {
        <div class="subinformations">
          <div class="d-flex mt-3 w-100 justify-content-end">
            @if (hasScheduledOrder) {
              <button class="btn btn-link small" (click)="cancelTariffOrder()">{{ 'ai-tariff-card_cancel_order_btn' | i18next }}</button>
            }
            <button [disabled]="hasScheduledOrder" class="btn btn-outline-primary" (click)="changeTariff()">{{ 'ai-tariff-card_choose_tariff_btn' | i18next }}</button>
          </div>
        </div>
      }
    </div>
</div>
}